import React from 'react'
import './print.css'
var dateFormat = require('dateformat');

const PrintLetter = (props) => {
    const { state } = props.location
    if(!state) return null
    const { fields_value, fields, addressed, signature } = state.letter
    const user = state.user 
    let { template } = state.letter
   
    if(fields_value && fields){
        fields.forEach(field => {
            const value = fields_value.find(value => field._id === value.field_id)
            if(value){            
                var regex = new RegExp("{{" + field.name + "}}")
                template = template.replace(regex, value.value || '________________')
            }
    
        })
    }
    
    template = template.replace(/{{user.identity}}/g, user["NIM"] || '________________')
    template = template.replace(/{{user.name}}/g, user["NAMA"] || '________________')
    template = template.replace(/{{user.faculty}}/g, user["FAKULTAS"] || '________________')
    template = template.replace(/{{user.major}}/g, user["PROGRAM_STUDI"] || '________________')
    template = template.replace(/{{user.signature}}/g, signature || '')

    template = template.replace(/{{addressed.identity}}/g, addressed.identity || '________________')
    template = template.replace(/{{addressed.name}}/g, addressed.name || '________________')
    template = template.replace(/{{addressed.official}}/g, addressed.official || '________________')    

    var now = new Date();
    template = template.replace(/{{date}}/g, dateFormat(now, "dd/mm/yyyy") || '________________')
    template = template.replace(/{{date.year}}/g, dateFormat(now, "yyyy") || '________________')
    template = template.replace(/{{date.mounth}}/g, dateFormat(now, "mm") || '________________')
    template = template.replace(/{{date.}}/g, dateFormat(now, "dd") || '________________')
    setTimeout(() => window.print(), 2000)
    
    return(
        <div dangerouslySetInnerHTML={{__html : template}}>
            
        </div>
    )
}

export default PrintLetter